module.exports = __webpack_public_path__ + "7eca38ac3b71ccabfa6ca8ca3bc7299d.svg";